import Instance from '../../../Axios';

// New Actions for the app

const GetUnidades = () => async (dispatch) => {
  await Instance()
    .get(`/backend/unidades`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_UNIDADES', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetUnidades;
